import { getRequest } from 'utilities/service.utils';
import IdentityService from './identity.service.context';

export const getSiteApplications = async () => {
  return await getRequest(IdentityService, '/siteapplications');
};

export const verifyAppAuthorization = async (clientId: string) => {
  return await getRequest(
    IdentityService,
    `/users/me/authorization/${clientId}`
  );
};
